// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.DeleteModal_dashboard__VuWC- {
  width: calc(100% - 320px);
  position: relative;
  left: 310px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  height: calc(100vh - 160px);
  overflow-y: auto;
}

.DeleteModal_dashboardContain__u6PV5 {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_dashboardContain__u6PV5,
.DeleteModal_bodythemedark__\\+j06m .DeleteModal_dashboard__VuWC-,
.DeleteModal_bodythemedark__\\+j06m .DeleteModal_cont2__KIGjc {
  background-Color: #0f1824;
}

.DeleteModal_top_header__buyJx .DeleteModal_top_header_inner__HkgQ2 {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.DeleteModal_cont2__KIGjc {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  height: calc(100vh - 160px);
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.DeleteModal_footer__i9lwr {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.DeleteModal_bodythemelight__KlgHH {
  background-color: #fff;
  padding-top: 90px;
}

.DeleteModal_bodythemedark__\\+j06m {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.DeleteModal_headerthemelight__klH04 {
  background-color: #fff;
}

.DeleteModal_headerthemedark__67zL- {
  background-color: #132337;
}

.DeleteModal_top_header__buyJx {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.DeleteModal_menuthemelight__-s0n6 {
  background-color: #fff;
}

.DeleteModal_menuthemedark__24owU {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.DeleteModal_menulinklight__rMPzK span {
  color: #666666 !important;
}

.DeleteModal_menulinklight__rMPzK a {
  color: #CBCBCB !important;
}

.DeleteModal_menulinklight__rMPzK:hover span, .DeleteModal_menulinklight__rMPzK:hover a {
  color: #fff !important;
}

.DeleteModal_menulinkdarkSelected__b8UKB {
  background-color: #1c2e45;
  color: #3b82f6;
}

.DeleteModal_menuthemelight__-s0n6 .DeleteModal_menulinklightSelected__\\+3Y2- {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43;
}

.DeleteModal_menulinkdark__v2oCq {
  color: #92afd3 !important;
}

.DeleteModal_menulinklight__rMPzK:hover {
  color: #fff !important;
  background-color: #131F43;
}

.DeleteModal_menulinklight__rMPzK .DeleteModal_sub_arrow__tclju svg path {
  stroke: #CBCBCB !important;
}

.DeleteModal_menulinklight__rMPzK:hover .DeleteModal_sub_arrow__tclju svg path {
  stroke: #fff !important;
}

.DeleteModal_menulinkdark__v2oCq .DeleteModal_sub_arrow__tclju svg path {
  stroke: #92afd3 !important;
}

.DeleteModal_menulinkdark__v2oCq:hover .DeleteModal_sub_arrow__tclju svg path {
  stroke: #fff !important;
}

.DeleteModal_menulinkdark__v2oCq:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.DeleteModal_headinglight__rPrZ7 {
  color: #60677e;
}

.DeleteModal_headingdark__pm5mN {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.DeleteModal_searchboxlight__XRa5N {
  background-color: #fff;
  border: none;
}

.DeleteModal_searchboxdark__UxCGS {
  background-color: #132337;
  color: #fff;
  border: none;
}

.DeleteModal_searchboxdark__UxCGS::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.DeleteModal_tableheadlight__wAr-W {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.DeleteModal_tableheadlight__wAr-W th {
  color: #fff;
}

thead .DeleteModal_tableheadlight__wAr-W th:first-child,
thead .DeleteModal_tableheaddark__L-bWe th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .DeleteModal_tableheadlight__wAr-W th:last-child,
thead .DeleteModal_tableheaddark__L-bWe th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.DeleteModal_table__-lfAe.DeleteModal_table-borderless__r3cpt {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.DeleteModal_tableheaddark__L-bWe {
  background-color: #132337;
  color: #fff;
}

.DeleteModal_table-borderless__r3cpt tr:nth-child(even) {
  background-color: #F9FAFB;
}

.DeleteModal_table-borderless__r3cpt .DeleteModal_left-section__kTDei {
  padding-top: 10px;
}

.DeleteModal_tablebodylight__6Ai9y td,
.DeleteModal_tablebodydark__3e1cB td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.DeleteModal_tablebodylight__6Ai9y {
  background-color: #fff;
}
.DeleteModal_tablebodylight__6Ai9y:hover {
  background-color: #ddecf9;
  cursor: auto;
}

.DeleteModal_tablebodydark__3e1cB {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.DeleteModal_tablebodydark__3e1cB:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: auto;
}

/* 
PAGINATION THEME COLOR
*/
.DeleteModal_paginationlight__o948\\+ {
  color: #60677e !important;
  font-size: 13px !important;
}

.DeleteModal_paginationdark__O4Vsl {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.DeleteModal_formthemelight__jqrbK {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.DeleteModal_formthemedark__GYW8e {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.DeleteModal_formthemedark__GYW8e ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.DeleteModal_viewformlight__YPo4- {
  background-color: #f3f6f9;
}

.DeleteModal_permissionboxlight__GnNaj {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.DeleteModal_permissionboxdark__agi1K {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.DeleteModal_errormsgclr__nk3-l {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.DeleteModal_graphclrlight__fXv3r {
  background-color: #fff;
}

.DeleteModal_graphclrdark__JmECA {
  background-color: #132337;
}

/* 
Counter theme
*/
#DeleteModal_card1bglight__dYlvA {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#DeleteModal_card1bgdark__Q2hjw {
  background: #392f28;
}

#DeleteModal_card2bglight__N7FlO {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#DeleteModal_card2bgdark__jUld4 {
  background: #1c3238;
}

#DeleteModal_card3bglight__sPu6M {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#DeleteModal_card3bgdark__rKcHN {
  background: #3a2434;
}

#DeleteModal_card4bglight__xxtQf {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#DeleteModal_card4bgdark__1hk4w {
  background: #2f264f;
}

#DeleteModal_card1bgdark__Q2hjw a, #DeleteModal_card1bgdark__Q2hjw p,
#DeleteModal_card2bgdark__jUld4 a, #DeleteModal_card2bgdark__jUld4 p,
#DeleteModal_card3bgdark__rKcHN a, #DeleteModal_card3bgdark__rKcHN p,
#DeleteModal_card4bgdark__1hk4w a, #DeleteModal_card4bgdark__1hk4w p {
  color: #fff;
}

/* 
Action button theme
*/
.DeleteModal_actionbtnlight__bn4Nx {
  color: rgba(70, 71, 91, 0.8705882353);
}

.DeleteModal_actionbtnlight__bn4Nx:hover {
  cursor: pointer;
}

.DeleteModal_actionbtndark__SYWtn {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.DeleteModal_profiledropdownlight__cjL9G {
  background-color: #fff;
}

.DeleteModal_profiledropdowndark__TEpvq {
  background-color: #151521;
}

.DeleteModal_settingsection__5q9Ua #DeleteModal_addform__xPmsX.DeleteModal_formthemedark__GYW8e .DeleteModal_savebtn__wghFI {
  background-color: #3b82f6;
  color: #fff;
}

#DeleteModal_addform__xPmsX.DeleteModal_formthemedark__GYW8e .DeleteModal_savebtn__wghFI {
  background-color: #3b82f6;
  color: #fff;
}

.DeleteModal_profile_conatiner__dXlZG {
  border-radius: 5px !important;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_ag-theme-alpine__i9ugX .DeleteModal_ag-row__i2M41 {
  background: #000 !important;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_formbtn__pdyV8 {
  background-color: #3b82f6;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_formbtn__pdyV8:hover {
  background-color: #2563eb;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_resetbtn__GYl7s {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_resetbtn__GYl7s:hover {
  background-color: #3b82f6;
}

.DeleteModal_headingdark__pm5mN span {
  background-color: #132337;
}

.DeleteModal_resetbtn__GYl7s {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131F43;
  color: #131F43;
  min-width: 113px;
}

.DeleteModal_resetbtn__GYl7s:hover,
.DeleteModal_resetbtn__GYl7s:active,
.DeleteModal_resetbtn__GYl7s:focus {
  background-color: #131F43;
  color: #fff;
}

.DeleteModal_addBtn__mw15J {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.DeleteModal_addbtnlight__Pq8dx {
  background-color: #38A169;
}

.DeleteModal_addbtndark__ylY4H {
  background-color: #3b82f6;
}

.DeleteModal_addbtndark__ylY4H:hover {
  background-color: #2563eb;
}

.DeleteModal_formthemedark__GYW8e label {
  color: #92afd3;
}

.DeleteModal_addBtn__mw15J svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.DeleteModal_addBtn__mw15J:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.DeleteModal_cust_addBtn__J0PRE.DeleteModal_addBtn__mw15J svg {
  top: 2px;
}

.DeleteModal_deleteBtn__FbiXC {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.DeleteModal_deleteBtn__FbiXC {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.DeleteModal_deleteBtn__FbiXC:active, .DeleteModal_deleteBtn__FbiXC:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.DeleteModal_deleteBtn__FbiXC svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.DeleteModal_deleteBtn__FbiXC:hover,
.DeleteModal_deleteBtn__FbiXC:active,
.DeleteModal_deleteBtn__FbiXC:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.DeleteModal_confirmBtn__gQQu6 {
  background-color: #131F43;
}

.DeleteModal_confirmBtn__gQQu6:hover,
.DeleteModal_confirmBtn__gQQu6:active,
.DeleteModal_confirmBtn__gQQu6:focus {
  background-color: #131F43;
}

.DeleteModal_confirmBtn__gQQu6 svg {
  top: 0;
}

.DeleteModal_delPopContainer__kh1eQ .DeleteModal_modal-body__4WUNx {
  padding: 25px;
  text-align: center;
}

.DeleteModal_delPopContainer__kh1eQ .DeleteModal_delet_icon__EasKH {
  margin-bottom: 11px;
}

.DeleteModal_delPopContainer__kh1eQ p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.DeleteModal_arrowback__Ghk3Y svg {
  fill: #000;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_arrowback__Ghk3Y {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_arrowback__Ghk3Y svg {
  fill: #3b82f6;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_drpdwn_btn__zZW\\+u {
  background-color: #132337;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_empname__MSWvd {
  color: #92afd3 !important;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_navitemli__Z20gi a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_tabnavli__8mk8t a.DeleteModal_settingsgeneral__Dh27T,
.DeleteModal_bodythemedark__\\+j06m .DeleteModal_tabnavli__8mk8t a.DeleteModal_settingslinks__6nt8Q:hover {
  background-color: #3b82f6;
  color: #fff;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_tabnavli__8mk8t a.DeleteModal_settingslinks__6nt8Q {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.DeleteModal_headerthemedark__67zL- .DeleteModal_dropdown_menu_contain__VnQJH {
  background-color: #1c2e45;
  color: #fff;
}

.DeleteModal_headerthemedark__67zL- .DeleteModal_dropdown_menu_contain__VnQJH ul li a,
.DeleteModal_headerthemedark__67zL- .DeleteModal_dropdown_menu_contain__VnQJH .DeleteModal_dropdown_item__LKHIL,
.DeleteModal_headerthemedark__67zL- .DeleteModal_dropdown_menu_contain__VnQJH .DeleteModal_dropdown_item__LKHIL h5 {
  color: #fff;
}

.DeleteModal_headerthemedark__67zL- .DeleteModal_dropdown_menu_contain__VnQJH ul li a:hover,
.DeleteModal_headerthemedark__67zL- .DeleteModal_dropdown_menu_contain__VnQJH .DeleteModal_dropdown_item__LKHIL:hover {
  background-color: #132337;
  color: #fff;
}

.DeleteModal_dropdown_item__LKHIL:active {
  background-color: #F5F6FA;
}

.DeleteModal_profile_arrrow_dwn__57nW7 {
  stroke: #132337;
}

.DeleteModal_headerthemedark__67zL- .DeleteModal_profile_arrrow_dwn__57nW7 {
  stroke: #fff;
}

.DeleteModal_dateinputbox1__wEgyI input,
.DeleteModal_dateinputbox1__wEgyI span {
  color: #fff !important;
}

/* LOGOUT MODAL */
@media only screen and (max-width: 1200px) {
  .DeleteModal_tableheadlight__wAr-W th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .DeleteModal_dashboard__VuWC- {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
  .DeleteModal_cont2__KIGjc {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
     height: auto !important;
   }*/
}
@media only screen and (max-width: 767px) {
  .DeleteModal_sectionright__SrAvI {
    float: unset !important;
  }
  .DeleteModal_dashboard__VuWC- {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .DeleteModal_cont2__KIGjc {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px !important;
  }
  .DeleteModal_bodythemelight__KlgHH, .DeleteModal_bodythemedark__\\+j06m {
    padding-top: 110px;
  }
}
@media (min-width: 576px) {
  .DeleteModal_exer_modal_contain__oga9o .DeleteModal_modal-dialog__pY6LO {
    max-width: 1055px;
  }
  .DeleteModal_delPopContainer__kh1eQ .DeleteModal_modal-dialog__pY6LO {
    max-width: 350px;
  }
}
.DeleteModal_resetbtn__GYl7s {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131F43;
  color: #131F43;
  min-width: 113px;
  min-height: 50px;
  margin-right: 24px;
}

.DeleteModal_resetbtn__GYl7s svg {
  margin-right: 10px;
  position: relative;
  top: -1px;
}

.DeleteModal_resetbtn__GYl7s:hover svg,
.DeleteModal_resetbtn__GYl7s:active svg,
.DeleteModal_resetbtn__GYl7s:focus svg {
  fill: #fff;
}

@media only screen and (max-width: 360px) {
  .DeleteModal_resetbtn__GYl7s {
    min-width: 100px;
    margin-right: 15px;
  }
  .DeleteModal_deleteBtn__FbiXC {
    min-width: 100px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/components/DeleteModal/DeleteModal.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAkDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA1FO;EA2FP,2BAAA;EACA,gBAAA;ACxEF;;AD0EA;EACE,yBAAA;EACA,yBAhGO;EAiGP,kBAAA;ACvEF;;ADyEA;;;EAGE,yBAlEoB;ACJtB;;ADwEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACrEF;;ADwEA;;CAAA;AAIA;EACE,wBAvCU;EAwCV,UAvCS;EAwCT,kBAAA;EACA,aA/CiB;EAgDjB,kBAAA;EACA,mBAxHO;EAyHP,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;ACnEF;;AD4EA;EACE,YAAA;ACzEF;;AD4EA;EACE,sBA5FY;ACmBd;;AD4EA;;CAAA;AAGA;EACE,sBAnGY;EAoGZ,iBAAA;ACzEF;;AD2EA;EACE,yBAlHgB;EAmHhB,iBAAA;ACxEF;;AD2EA;;CAAA;AAGA;EACE,sBA/GY;ACuCd;;AD2EA;EACE,yBA9HgB;ACsDlB;;AD0EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;ACvEF;;AD0EA;;CAAA;AAGA;EACE,sBAnIY;AC4Dd;;ADyEA;EACE,yBAjJgB;AC2ElB;;ADyEA;;CAAA;AAGA;EACE,yBAAA;ACtEF;;ADyEA;EACE,yBAAA;ACtEF;;ADyEA;EACE,sBAAA;ACtEF;;ADyEA;EACE,yBAlKsB;EAmKtB,cA7KkB;ACuGpB;;ADwEA;EACE,sCAAA;EACA,sBAAA;EACA,yBA5Mc;ACuIhB;;ADwEA;EACE,yBAAA;ACrEF;;ADwEA;EACE,sBAAA;EACA,yBArNc;ACgJhB;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,yBArMsB;EAsMtB,WA7LY;ACwHd;;ADwEA;;CAAA;AAGA;EACE,cAjMe;AC4HjB;;ADwEA;EACE,cArMe;ACgIjB;;ADwEA;;CAAA;AAGA;EACE,sBA/MY;EAgNZ,YAAA;ACrEF;;ADwEA;EACE,yBA/NgB;EAgOhB,WArNY;EAsNZ,YAAA;ACrEF;;ADuEA;EACE,cAtNe;ACkJjB;;ADuEA;;CAAA;AAGA;EACE,yBA7Qc;EA8Qd,8BAAA;ACpEF;;ADsEA;EACE,WApOY;ACiKd;;ADqEA;;EAEE,0BAAA;AClEF;;ADoEA;;EAEE,0BAAA;ACjEF;;ADmEA;EACE,kBAAA;AChEF;;ADkEA;EACE,kBAAA;AC/DF;;ADiEA;EACE,oCAAA;EACA,gCAAA;AC9DF;;ADiEA;EACE,yBAlPkB;EAmPlB,WA3PY;AC6Ld;;ADgEA;EACE,yBAAA;AC7DF;;AD+DA;EACE,iBAAA;AC5DF;;AD8DA;;EAEE,+BAAA;EACA,iBAAA;AC3DF;;AD6DA;EACE,sBAzQY;AC+Md;AD4DE;EACE,yBAAA;EACA,YAAA;AC1DJ;;AD6DA;EACC,0CAAA;EACC,cA/Qe;ACqNjB;AD4DE;EACE,yCAAA;EACA,YAAA;AC1DJ;;AD8DA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,0BAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBA1SY;EA2SZ,yBAAA;EACA,qDAAA;AC1DF;;AD4DA;EACE,yBAvSkB;EAwSlB,yBAAA;EACA,eAAA;ACzDF;AD2DE;EACE,cAjTa;ACwPjB;;AD8DA;;CAAA;AAGA;EACE,yBAhUgB;ACqQlB;;AD8DA;EACE,yBAAA;EACA,yBAAA;AC3DF;;AD6DA;EACE,yBA/UoB;EAgVpB,yBAAA;AC1DF;;AD6DA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAnVY;ACyRd;;AD6DA;EACE,yBA/UkB;ACqRpB;;AD8DA;;CAAA;AAGA;EACE,iGAAA;EACA,sBAhWY;ACqSd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAzWY;AC8Sd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAlXY;ACuTd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBA3XY;ACgUd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;;;;EAIE,WAtYY;AC2Ud;;AD8DA;;CAAA;AAGA;EACE,qCAAA;AC3DF;;AD6DA;EACE,eAAA;AC1DF;;AD4DA;EACE,cAhZe;ACuVjB;;AD6DA;;CAAA;AAGA;EACE,sBAAA;AC1DF;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,yBApbkB;EAqblB,WApaY;AC0Wd;;AD4DA;EACE,yBAxbkB;EAyblB,WAxaY;AC+Wd;;AD4DA;EACE,6BAAA;ACzDF;;AD4DA;EACE,2BAAA;ACzDF;;AD4DA;EACE,yBArckB;AC4YpB;;AD4DA;EACE,yBAxcwB;AC+Y1B;;AD4DA;EACE,WA5bY;EA6bZ,6BAAA;EACA,yBAAA;ACzDF;;AD4DA;EACE,yBAndkB;AC0ZpB;;AD6DA;EACE,yBAldgB;ACwZlB;;AD6DA;EACE,eAAA;EACA,gBA/fc;EAggBd,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cA7fc;EA8fd,gBAAA;AC1DF;;AD4DA;;;EAGE,yBAngBc;EAogBd,WAvdY;AC8Zd;;AD4DA;EACE,gBAAA;EACA,YAAA;EACA,WA7dY;EA8dZ,yBAzfY;EA0fZ,YAAA;EACA,eAAA;EACA,gBAphBc;AC2dhB;;AD4DA;EACE,yBAhgBY;ACucd;;AD2DA;EACE,yBAzfkB;ACicpB;;AD0DA;EACE,yBA3fwB;ACoc1B;;AD0DA;EACE,cAjgBiB;AC0cnB;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACxDF;;AD2DA;EACE,WA1fY;EA2fZ,yBAthBY;EAuhBZ,YAAA;ACxDF;;AD2DA;EACE,QAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBA1hBW;EA2hBX,WAvgBY;EAwgBZ,eAAA;EACA,gBA5jBc;EA6jBd,YAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBApiBW;EAqiBX,WAjhBY;EAkhBZ,eAAA;EACA,gBAtkBc;EAukBd,YAAA;ACxDF;;AD2DA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACxDF;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACxDF;;AD2DA;;;EAGE,yBA1jBW;EA2jBX,WAviBY;EAwiBZ,YAAA;ACxDF;;AD2DA;EACE,yBAzlBc;ACiiBhB;;AD2DA;;;EAGE,yBA/lBc;ACuiBhB;;AD2DA;EACE,MAAA;ACxDF;;AD6DA;EACE,aAAA;EACA,kBAAA;AC1DF;;AD6DA;EACE,mBAAA;AC1DF;;AD6DA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AC1DF;;AD6DA;EACE,UAAA;AC1DF;;AD6DA;EACE,yCA9lBc;EA+lBd,cAnmBkB;ACyiBpB;;AD6DA;EACE,aAvmBkB;AC6iBpB;;AD6DA;EACE,yBAnmBgB;ACyiBlB;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,6BAAA;EACA,yBAAA;EACA,WAlmBY;ACwiBd;;AD6DA;;EAEE,yBAxnBkB;EAynBlB,WAxmBY;AC8iBd;;AD4DA;EACE,6BAAA;EACA,yBAAA;EACA,WA7mBY;ACojBd;;AD4DA;EACE,yBA1nBsB;EA2nBtB,WAlnBY;ACyjBd;;AD4DA;;;EAGE,WAxnBY;AC+jBd;;AD4DA;;EAEE,yBAxoBgB;EAyoBhB,WA9nBY;ACqkBd;;AD4DA;EACE,yBAhrBO;ACunBT;;AD4DA;EACE,eAjpBgB;ACwlBlB;;AD4DA;EACE,YA1oBY;ACilBd;;AD4DA;;EAEE,sBAAA;ACzDF;;AD4DA,iBAAA;AAUA;EACE;IACE,gBAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;EClEF;EDoEA;IACE,2BAAA;IACA,gBAAA;EClEF;AACF;ADoEA;EACC;;KAAA;AChED;ADoEA;EACE;IACE,uBAAA;EClEF;EDoEA;IACE,6BAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;EClEF;EDoEA;IACE,kBAAA;EClEF;AACF;ADqEA;EACE;IACI,iBAAA;ECnEJ;EDqEA;IACI,gBAAA;ECnEJ;AACF;AApsBA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cDSY;ECRZ,gBAAA;EACA,gBAAA;EACA,kBAAA;AAssBJ;;AAnsBA;EACI,kBAAA;EACA,kBAAA;EACA,SAAA;AAssBJ;;AAnsBA;;;EAGI,UDuCU;AC+pBd;;AAlsBA;EACI;IACI,gBAAA;IACA,kBAAA;EAqsBN;EAnsBE;IACI,gBAAA;EAqsBN;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 310px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  height: calc(100vh - 160px);\n  min-height: auto !important;\n  overflow-y: auto;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinklight .sub_arrow svg path{\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path{\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: auto;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: auto;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n.actionbtnlight:hover{\n  cursor: pointer;\n}\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark; \n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item, \n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input, \n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {\n\n}\n\n.modalStyleDark {\n  \n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n  .cont2 {\n    height: calc(100vh - 160px);\n    overflow-y: auto;\n  }\n}\n@media only screen and (max-width: 998px) { \n /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 110px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n\n.resetbtn {\n    font-size: 16px;\n    font-weight: 600;\n    border-radius: 5px;\n    background-color: transparent;\n    border: solid 1px $primary-color;\n    color: $primary-color;\n    min-width: 113px;\n    min-height: 50px;\n    margin-right: 24px;\n}\n\n.resetbtn svg {\n    margin-right: 10px;\n    position: relative;\n    top: -1px;\n}\n\n.resetbtn:hover svg,\n.resetbtn:active svg,\n.resetbtn:focus svg {\n    fill: $white-color;\n}\n\n\n@media only screen and (max-width: 360px) {\n    .resetbtn {\n        min-width: 100px;\n        margin-right: 15px;\n    }\n    .deleteBtn {\n        min-width: 100px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `DeleteModal_dashboard__VuWC-`,
	"dashboardContain": `DeleteModal_dashboardContain__u6PV5`,
	"bodythemedark": `DeleteModal_bodythemedark__+j06m`,
	"cont2": `DeleteModal_cont2__KIGjc`,
	"top_header": `DeleteModal_top_header__buyJx`,
	"top_header_inner": `DeleteModal_top_header_inner__HkgQ2`,
	"footer": `DeleteModal_footer__i9lwr`,
	"bodythemelight": `DeleteModal_bodythemelight__KlgHH`,
	"headerthemelight": `DeleteModal_headerthemelight__klH04`,
	"headerthemedark": `DeleteModal_headerthemedark__67zL-`,
	"menuthemelight": `DeleteModal_menuthemelight__-s0n6`,
	"menuthemedark": `DeleteModal_menuthemedark__24owU`,
	"menulinklight": `DeleteModal_menulinklight__rMPzK`,
	"menulinkdarkSelected": `DeleteModal_menulinkdarkSelected__b8UKB`,
	"menulinklightSelected": `DeleteModal_menulinklightSelected__+3Y2-`,
	"menulinkdark": `DeleteModal_menulinkdark__v2oCq`,
	"sub_arrow": `DeleteModal_sub_arrow__tclju`,
	"headinglight": `DeleteModal_headinglight__rPrZ7`,
	"headingdark": `DeleteModal_headingdark__pm5mN`,
	"searchboxlight": `DeleteModal_searchboxlight__XRa5N`,
	"searchboxdark": `DeleteModal_searchboxdark__UxCGS`,
	"tableheadlight": `DeleteModal_tableheadlight__wAr-W`,
	"tableheaddark": `DeleteModal_tableheaddark__L-bWe`,
	"table": `DeleteModal_table__-lfAe`,
	"table-borderless": `DeleteModal_table-borderless__r3cpt`,
	"left-section": `DeleteModal_left-section__kTDei`,
	"tablebodylight": `DeleteModal_tablebodylight__6Ai9y`,
	"tablebodydark": `DeleteModal_tablebodydark__3e1cB`,
	"paginationlight": `DeleteModal_paginationlight__o948+`,
	"paginationdark": `DeleteModal_paginationdark__O4Vsl`,
	"formthemelight": `DeleteModal_formthemelight__jqrbK`,
	"formthemedark": `DeleteModal_formthemedark__GYW8e`,
	"viewformlight": `DeleteModal_viewformlight__YPo4-`,
	"permissionboxlight": `DeleteModal_permissionboxlight__GnNaj`,
	"permissionboxdark": `DeleteModal_permissionboxdark__agi1K`,
	"errormsgclr": `DeleteModal_errormsgclr__nk3-l`,
	"graphclrlight": `DeleteModal_graphclrlight__fXv3r`,
	"graphclrdark": `DeleteModal_graphclrdark__JmECA`,
	"card1bglight": `DeleteModal_card1bglight__dYlvA`,
	"card1bgdark": `DeleteModal_card1bgdark__Q2hjw`,
	"card2bglight": `DeleteModal_card2bglight__N7FlO`,
	"card2bgdark": `DeleteModal_card2bgdark__jUld4`,
	"card3bglight": `DeleteModal_card3bglight__sPu6M`,
	"card3bgdark": `DeleteModal_card3bgdark__rKcHN`,
	"card4bglight": `DeleteModal_card4bglight__xxtQf`,
	"card4bgdark": `DeleteModal_card4bgdark__1hk4w`,
	"actionbtnlight": `DeleteModal_actionbtnlight__bn4Nx`,
	"actionbtndark": `DeleteModal_actionbtndark__SYWtn`,
	"profiledropdownlight": `DeleteModal_profiledropdownlight__cjL9G`,
	"profiledropdowndark": `DeleteModal_profiledropdowndark__TEpvq`,
	"settingsection": `DeleteModal_settingsection__5q9Ua`,
	"addform": `DeleteModal_addform__xPmsX`,
	"savebtn": `DeleteModal_savebtn__wghFI`,
	"profile_conatiner": `DeleteModal_profile_conatiner__dXlZG`,
	"ag-theme-alpine": `DeleteModal_ag-theme-alpine__i9ugX`,
	"ag-row": `DeleteModal_ag-row__i2M41`,
	"formbtn": `DeleteModal_formbtn__pdyV8`,
	"resetbtn": `DeleteModal_resetbtn__GYl7s`,
	"addBtn": `DeleteModal_addBtn__mw15J`,
	"addbtnlight": `DeleteModal_addbtnlight__Pq8dx`,
	"addbtndark": `DeleteModal_addbtndark__ylY4H`,
	"cust_addBtn": `DeleteModal_cust_addBtn__J0PRE`,
	"deleteBtn": `DeleteModal_deleteBtn__FbiXC`,
	"confirmBtn": `DeleteModal_confirmBtn__gQQu6`,
	"delPopContainer": `DeleteModal_delPopContainer__kh1eQ`,
	"modal-body": `DeleteModal_modal-body__4WUNx`,
	"delet_icon": `DeleteModal_delet_icon__EasKH`,
	"arrowback": `DeleteModal_arrowback__Ghk3Y`,
	"drpdwn_btn": `DeleteModal_drpdwn_btn__zZW+u`,
	"empname": `DeleteModal_empname__MSWvd`,
	"navitemli": `DeleteModal_navitemli__Z20gi`,
	"tabnavli": `DeleteModal_tabnavli__8mk8t`,
	"settingsgeneral": `DeleteModal_settingsgeneral__Dh27T`,
	"settingslinks": `DeleteModal_settingslinks__6nt8Q`,
	"dropdown_menu_contain": `DeleteModal_dropdown_menu_contain__VnQJH`,
	"dropdown_item": `DeleteModal_dropdown_item__LKHIL`,
	"profile_arrrow_dwn": `DeleteModal_profile_arrrow_dwn__57nW7`,
	"dateinputbox1": `DeleteModal_dateinputbox1__wEgyI`,
	"sectionright": `DeleteModal_sectionright__SrAvI`,
	"exer_modal_contain": `DeleteModal_exer_modal_contain__oga9o`,
	"modal-dialog": `DeleteModal_modal-dialog__pY6LO`
};
export default ___CSS_LOADER_EXPORT___;
